import { render, staticRenderFns } from "./PbReplacements.vue?vue&type=template&id=0591b752&"
import script from "./PbReplacements.vue?vue&type=script&lang=js&"
export * from "./PbReplacements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports